<template>
  <div class="row">
    <div :class="{'col-lg-12': !isAuditingOrg}" class="col-lg-6 col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Linked Audits
          </h4>
          <h6 class="card-subtitle">
            Audits linked to this audit
          </h6>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th scope="col">
                  #
                </th>
                <th class="text-left" scope="col">
                  Audit
                </th>
                <th class="text-left" scope="col">
                  Auditor
                </th>
                <th class="text-center" scope="col">
                  Action
                </th>
              </tr>
              </thead>
              <tbody>
              <tr :key="a.audit_id" v-for="(a, index) in linkedAudits">
                <td>{{ index + 1 }}</td>
                <td class="text-left">
                  <router-link :to="{name: 'viewaudit', params: {auditId: a.audit_id}}" class="text-info"
                               target="_blank">
                    {{ a.audit_id }}
                  </router-link>
                </td>
                <td>{{ a.auditors }}</td>

                <td class="text-center">
                  <button @click="setAuditToUnlink(a.audit_id)"
                          class="btn rounded btn-sm btn-danger waves-effect waves-light m-l-5"
                          data-target="#approveModal" data-toggle="modal"
                          type="button">
                    <i class="fas fa-trash-alt"/>
                  </button>

                  <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="approveModal"
                       role="dialog" tabindex="-1">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-body card-blue">
                          <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"/>
                            <br><br>
                            <h4>
                              Are you sure you want to
                              unlink this audit?
                            </h4>
                            <button :disabled="isDeleted" @click="unlink"
                                    class="btn waves-effect waves-light btn-success m-r-15" type="button">
                              <span v-if="!isDeleted">Yes</span>
                              <span v-if="isDeleted"><i class="fa fa-spinner fa-spin"/> &nbsp;Loading</span>
                            </button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                              No
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card" v-if="linkedAudits.length <= 0">
        <div class="card-header">
          <h4 class="card-title text-center">
            There are no linked audits yet.
          </h4>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-12" v-if="isAuditingOrg">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Link Audit
          </h4>
          <h6 class="card-subtitle">
            Select a Audit and link to this Audit
          </h6>
        </div>
        <div class="card-body">
          <div class="form-group row upload-form">
            <label class="control-label col-md-2">Select Audit</label>
            <div class="col-md-8">
              <multiselect :options="audits" class="form-control" data-vv-as="Audit" id="audit"
                           label="audit" name="audit" placeholder="Select an Audit" track-by="audit"
                           v-model="audit_to_link" v-validate="'required'">
                <template slot="singleLabel" slot-scope="props">
                  Audit# {{ props.option.audit }}
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <h5>Audit{{ '('+ props.option.certification_name+ ')' }} #{{ props.option.audit_id }}</h5>
                    <p>{{ props.option.created_at | timestamp }}</p>
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="col-md-2">
              <button @click="link" class="btn waves-effect waves-light btn-success" type="submit">
                Save
              </button>
            </div>
          </div>
          <div class="form-group row">
            <img alt="" class="loader-gif center" src="../../../assets/images/loader.gif">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {mapGetters} from 'vuex';
  import {apiMixin} from '@/utils/api-mixin';

  export default {
    name: 'AuditLink',
    components: {Multiselect},
    mixins: [apiMixin('audit')],
    props: ['auditId', 'auditType', 'isAuditingOrg'],
    data() {
      return {
        linkedAudits: [],
        audits: [],
        audit_to_link: null,
        isDeleted: false,
        audit_to_unlink: null
      };
    },
    computed: {
      ...mapGetters(['currentUser', 'activeGroup'])
    },
    mounted() {
      $('.loader-gif').hide();
      this.init();
    },
    methods: {
      async init() {
        await this.getLinkedAudits();
        await this.getAudits();
      },
      async getAudits() {
        try {
          const reply = await this.$api.get('/audits/by_auditing_org');
          this.audits = reply.data.filter(a => (a.status === 'Completed' && a.audit_id !== this.auditId));
        } catch (e) {
          console.error(e);
        }
      },
      async link() {
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit linked', async () => {
          await this.$api.post(`/audits/${this.auditId}/link`, {
            child_audit: this.audit_to_link.audit_id
          });
        });
        if (isProposal) {
          this.$router.push({name: 'proposals'});
        }
        await this.init();
      },
      async getLinkedAudits() {
        try {
          const {data} = await this.$api.get(`/audits/${this.auditId}/link`);
          this.linkedAudits = data;
        } catch (e) {
          console.log(e);
        }
      },
      setAuditToUnlink(audit) {
        this.audit_to_unlink = audit;
      },
      async unlink() {
        $('#approveModal').modal('toggle');
        this.isDeleted = true;
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit unlinked', async () => {
          await this.$api.delete(`/audits/${this.auditId}/link`, {
            data: {
              child_audit: this.audit_to_unlink
            }
          });
        });
        if (isProposal) {
          this.$router.push({name: 'proposals'});
        }
        this.isDeleted = false;
        await this.init();
      }
    }
  }
</script>

<style scoped>
</style>
